import axios from "axios";
import { createStore } from 'vuex'
import router from './../router'

export const useAuthStore = createStore({
    state () {
        return {
            authenticated : false,
            user : null,
        }
    },
    mutations: {
        setAuthenticated(state, bool) {
            this.authenticated = bool;
        }
    },
    actions : {
        async getUser() {
            await axios.get("/sanctum/csrf-cookie");
                return axios.get('/api/user').then(({data})=>{
                    if (data.api_token != null && data.api_token != "") {
                        this.authenticated = true;
                        this.user = data.data;
                        Sentry.setUser({ email: data.data.email });
                        router.push({name:'dashboard'});
                    }
                }).catch((response)=>{
                    this.user = {};
                    this.authenticated = false;
                });
        },
        async logout() {
            await axios.get('/api/logout').then(({data})=>{
                this.authenticated = false;
                router.push({name:'login'});
            });
        }
    }
  })
